function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { PureComponent } from "react";
import VisibilitySensor from "react-visibility-sensor";
import classNames from "classnames";
import { withGenericConfig } from "/contexts/generic-config-context";
import { withAbTests } from "/contexts/ab-tests-context";
import { generateOnKeyDownHandler, preventFocusOnMouseDown } from "client/services/accessibility/accessibility-service";
import { getPlans } from "services/pricing/plans-service";
import { getPlanFeatures } from "services/pricing-features-service";
import { trackEvent } from "services/bigbrain-service";
import { SEE_COMPLETE_FEATURES_LIST_CLICKED } from "constants/bigbrain-event-types";
import { TIERS_STICKY_HEADER_BORDER_OFFSET } from "constants/pricing-sizes";
import PricingFeaturesSection from "segments/desktop/core-components/pricing-features-section/pricing-features-section";
import DownArrow from "/static/svg/arrow-down.svg";
import StickyTableHeaderComponent from "./sticky-table-header/sticky-table-header-component";
import { StyledFeaturesTableComponent } from "./features-table-component.scss";
class FeaturesTableComponent extends PureComponent {
    render() {
        const { translateOrTranslateWithParam, abTests, forcePricing, hasFreeTier, hasStudentPlan, cookies, ignoreClusterConfig } = this.props;
        const { clusterConfig, clusterId } = ignoreClusterConfig ? {
            clusterConfig: {},
            clusterId: undefined
        } : this.props;
        const params = {
            hasStudentPlan,
            hasFreeTier,
            abTests,
            cookies,
            clusterId,
            clusterConfig,
            forcePricing
        };
        const plans = getPlans(params);
        const tableSections = getPlanFeatures(params);
        const { hasBorder, shouldSeeFeaturesList } = this.state;
        const featuresListButtonTitleText = shouldSeeFeaturesList ? "pricingPage.hideCompleteFeaturesList" : "pricingPage.seeCompleteFeaturesList";
        return /*#__PURE__*/ _jsxs(StyledFeaturesTableComponent, {
            className: "features-table-component",
            role: "table",
            children: [
                /*#__PURE__*/ _jsxs("div", {
                    className: classNames("see-complete-feature-list-container", {
                        "list-hidden": !shouldSeeFeaturesList
                    }),
                    role: "button",
                    title: translateOrTranslateWithParam(featuresListButtonTitleText),
                    onClick: this.toggleFeaturesList,
                    onMouseDown: preventFocusOnMouseDown,
                    onKeyDown: generateOnKeyDownHandler(this.toggleFeaturesList),
                    tabIndex: 0,
                    children: [
                        /*#__PURE__*/ _jsx("h2", {
                            className: "see-complete-feature-list-text",
                            children: translateOrTranslateWithParam("pricingPage.completeFeaturesList")
                        }),
                        /*#__PURE__*/ _jsx("div", {
                            className: "see-complete-feature-list-button",
                            "aria-hidden": true,
                            children: /*#__PURE__*/ _jsx(DownArrow, {})
                        })
                    ]
                }),
                shouldSeeFeaturesList && /*#__PURE__*/ _jsxs(_Fragment, {
                    children: [
                        /*#__PURE__*/ _jsx(StickyTableHeaderComponent, {
                            plans: plans,
                            hasBorder: hasBorder
                        }),
                        /*#__PURE__*/ _jsx(VisibilitySensor, {
                            offset: {
                                top: TIERS_STICKY_HEADER_BORDER_OFFSET
                            },
                            onChange: this.onVisibilityChange,
                            children: /*#__PURE__*/ _jsx("div", {
                                className: "tiers-sticky-header-visibility-checkpoint"
                            })
                        }),
                        /*#__PURE__*/ _jsx("div", {
                            className: "features-list-sections",
                            children: tableSections.map((section)=>{
                                const { sectionName } = section;
                                return /*#__PURE__*/ _jsx("div", {
                                    className: "section-container",
                                    children: /*#__PURE__*/ _jsx(PricingFeaturesSection, {
                                        section: section,
                                        plans: plans,
                                        sectionHeaderID: this.getSectionHeaderId(sectionName)
                                    })
                                }, sectionName);
                            })
                        })
                    ]
                })
            ]
        });
    }
    constructor(props){
        super(props);
        _define_property(this, "onVisibilityChange", (isSeen)=>{
            this.setState({
                hasBorder: !isSeen
            });
        });
        _define_property(this, "getSectionHeaderId", (sectionName)=>`featuresSection_${sectionName}`);
        _define_property(this, "toggleFeaturesList", ()=>{
            const { clusterId } = this.props;
            const newValue = !this.state.shouldSeeFeaturesList;
            trackEvent(SEE_COMPLETE_FEATURES_LIST_CLICKED, {
                info1: newValue ? "shown" : "hidden",
                placement: "homepage_minisite",
                kind: clusterId
            });
            this.setState({
                shouldSeeFeaturesList: !this.state.shouldSeeFeaturesList
            });
        });
        this.state = {
            shouldSeeFeaturesList: false,
            hasBorder: false
        };
    }
}
export default withAbTests(withGenericConfig(FeaturesTableComponent));
